import {computed, ref, watch} from "vue";

export default function (props, emit) {
    const list = ref([]);

    const model = computed({
        get: () => props.value,

        set(value) {
            emit('input', value)
        }
    });

    watch(() => props.value, (value) => {
        if (value) {
            list.value = [value];
        } else {
            list.value = [];
        }
    })

    async function updateList(query) {
        if (query.length) {
            let {data} = await props.getListMethod(query);

            list.value = data.filter(item => props.excludeIds?.length ? !props.excludeIds.includes(item.id) : true);
        } else {
            list.value = [];
        }
    }

    return {
        model,
        list,
        updateList
    }
}
